/* ============================================================
   AM LUXURY — elevated system behaviour
   · .lux-rise scroll reveal (mirrors the mockup)
   · product-card "Add to bag" → real /cart/add.js + live bag count
   · wishlist heart → remembered per browser
   ============================================================ */
(function () {
  'use strict';

  var ROUTES = window.LUX_ROUTES || {};
  var ADD_URL = ROUTES.cart_add || '/cart/add.js';
  var CART_URL = ROUTES.cart || '/cart.js';

  /* ---------- scroll reveal ---------- */
  function reveal(root) {
    var els = (root || document).querySelectorAll('.lux-rise:not(.lux-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('lux-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lux-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  /* ---------- bag count ---------- */
  function paintCount(count) {
    var nodes = document.querySelectorAll('[data-lux-cart-count]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = count;
  }

  function refreshCount() {
    return fetch(CART_URL, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('lux:cart:updated', { detail: cart }));
        return cart;
      })
      .catch(function () { /* leave the server-rendered count alone */ });
  }

  /* ---------- add to bag ---------- */
  var BAG_SVG = null;

  function addToBag(btn) {
    var id = btn.getAttribute('data-lux-atc');
    if (!id || btn.getAttribute('aria-busy') === 'true') return;

    if (BAG_SVG === null) BAG_SVG = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');

    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-done');
        btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5 10 17.5 19 7"/></svg>';
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.innerHTML = BAG_SVG;
        }, 1600);
        return refreshCount();
      })
      .catch(function () {
        /* Sold out, or the variant went away between render and click —
           send the shopper to the product page rather than failing silently. */
        btn.removeAttribute('aria-busy');
        var href = btn.getAttribute('data-lux-url');
        if (href) window.location.href = href;
      });
  }

  /* ---------- wishlist ---------- */
  var WKEY = 'lux:wishlist';

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; }
  }

  function writeWishlist(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }

  function paintWishlist(root) {
    var list = readWishlist();
    if (!list.length) return;
    var nodes = (root || document).querySelectorAll('[data-lux-fav]');
    for (var i = 0; i < nodes.length; i++) {
      if (list.indexOf(nodes[i].getAttribute('data-lux-fav')) !== -1) {
        nodes[i].classList.add('is-on');
        nodes[i].setAttribute('aria-pressed', 'true');
        nodes[i].textContent = '♥';
      }
    }
  }

  function toggleWishlist(btn) {
    var handle = btn.getAttribute('data-lux-fav');
    if (!handle) return;
    var list = readWishlist();
    var at = list.indexOf(handle);
    if (at === -1) {
      list.push(handle);
      btn.classList.add('is-on');
      btn.setAttribute('aria-pressed', 'true');
      btn.textContent = '♥';
    } else {
      list.splice(at, 1);
      btn.classList.remove('is-on');
      btn.setAttribute('aria-pressed', 'false');
      btn.textContent = '♡';
    }
    writeWishlist(list);
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var atc = e.target.closest ? e.target.closest('[data-lux-atc]') : null;
    if (atc) { e.preventDefault(); addToBag(atc); return; }

    var fav = e.target.closest ? e.target.closest('[data-lux-fav]') : null;
    if (fav) { e.preventDefault(); toggleWishlist(fav); }
  });

  /* ---------- rotating announcement bar ---------- */
  function startRotator(bar) {
    if (!bar || bar.dataset.luxBound === '1') return;
    bar.dataset.luxBound = '1';

    var msgs = Array.prototype.slice.call(bar.querySelectorAll('[data-lux-annc-msg]'));
    if (msgs.length < 2) return;

    var delay = Number(bar.getAttribute('data-lux-annc-interval')) || 4000;
    var i = msgs.indexOf(bar.querySelector('.is-on'));
    if (i < 0) i = 0;
    var timer = null;

    function show(next) {
      var current = msgs[i];
      current.classList.remove('is-on');
      current.classList.add('is-out');
      current.setAttribute('aria-hidden', 'true');
      setTimeout(function () { current.classList.remove('is-out'); }, 600);

      i = next;
      msgs[i].classList.add('is-on');
      msgs[i].removeAttribute('aria-hidden');
    }

    function play() {
      stop();
      timer = setInterval(function () { show((i + 1) % msgs.length); }, delay);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    /* Hold the current message while it is being read or interacted with. */
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', play);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { play(); }
    });

    play();
  }

  function init(root) {
    reveal(root);
    paintWishlist(root);
    var bars = (root || document).querySelectorAll('[data-lux-annc]');
    for (var i = 0; i < bars.length; i++) startRotator(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme editor: re-arm everything when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Collection "Load more" appends cards that still need their saved state. */
  document.addEventListener('lux:content:added', function () { init(); });
})();

/* ------------------------------------------------------------------
   Newsletter popup — first-order code
   Reveals the welcome code in place once the shopper subscribes, so
   they never have to go hunting in their inbox to use it.
   ------------------------------------------------------------------ */
(function () {
  var CODE = 'AMFAMILY10';

  function popupRoot() {
    return document.querySelector('[id*="newsletter_popup"], .js-newsletter-popup, [class*="newsletter-popup"]');
  }

  function reveal(scope) {
    if (!scope || scope.querySelector('.lux-code')) return;
    var form = scope.querySelector('form');
    var host = form || scope;

    var box = document.createElement('div');
    box.className = 'lux-code';
    box.setAttribute('role', 'status');
    box.innerHTML =
      '<span class="lux-code__label">Your code</span>' +
      '<button type="button" class="lux-code__value" data-lux-copy>' + CODE + '</button>' +
      '<span class="lux-code__hint">Tap to copy &middot; use it at checkout</span>';
    host.parentNode.insertBefore(box, host.nextSibling);

    box.querySelector('[data-lux-copy]').addEventListener('click', function (e) {
      var btn = e.currentTarget;
      var done = function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(CODE).then(done).catch(done);
      } else {
        done();
      }
    });
  }

  function start() {
    var root = popupRoot();
    if (!root) return;

    // already subscribed on this page load
    if (root.querySelector('.js-success')) reveal(root);

    root.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var email = form.querySelector('input[type="email"]');
      if (email && !email.checkValidity()) return;
      // reveal straight away; Shopify still processes the subscription
      setTimeout(function () { reveal(root); }, 60);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
